import { useContext, useMemo, useState } from 'react'
import { __ } from '@wordpress/i18n'
import Button from '../../Common/Button';
import Source from '../../Common/Source';
import ModalContainer from '../../Global/ModalContainer';
import AddSourceModal from '../../Modals/AddSourceModal';
import SbUtils from '../../../Utils/SbUtils';

const SelectSourcesSection = ( props ) => {

    const {
        sources,
        fbModal,
        editorNotification,
        isPro,
        fbManualModal
    } = useContext( SbUtils.getCurrentContext() );

    const [ addSourcesModalActive, setAddSourcesModalActive ] = useState( false );
    const [ collapsedSources, setCollapsedSources ] = useState( [] );



    const connectFacebookActiveMemo = useMemo( () => {
        if( fbModal.connectFacebookActive === true){
            setAddSourcesModalActive( true )
            return true;
        }
        return false;
    },[ fbModal ]);

    const addSourcePopup = () => {
        setAddSourcesModalActive( true )
    }
    return (
        <>
            <div
                className={'sb-'+props.context+'-content sb-fs'}
                data-context={ props.context }
            >
                {
                    sources.sourcesList.length !== 0 &&
                    <div className='sb-sources-list sb-fs'>
                        <Button
                            text={ __( 'Add New', 'sb-customizer' ) }
                            icon='plus'
                            customClass='sb-addnew-source'
                            boxshadow={ false }
                            size='small'
                            iconSize='14'
                            onClick={ () => {
                                addSourcePopup()
                            } }
                        />
                        {
                            sources.sourcesList.map( ( source, sourceInd ) => {
                                return (
                                    <Source
                                        key={ sourceInd }
                                        provider={ source.provider }
                                        checkbox={props.context !== 'settingspage' && true}
                                        isChecked={props.context !== 'settingspage' && props.selectedSources.includes( source.account_id ) }
                                        name={ source.name }
                                        removeIcon={ props.context === 'settingspage' }
                                        infoIcon={ props.context === 'settingspage' }
                                        accountId={ source.account_id }
                                        editorNotification={ editorNotification }
                                       isCollapsed={ collapsedSources.includes( source.account_id )  }
                                        onRemoveClick={ () => {
                                            props.context === 'settingspage' &&
                                                props.deleteSource( source );
                                        }}
                                        onClick={ () => {
                                            props.context !== 'settingspage' &&
                                                props.selectSourcesAction( source.account_id );
                                        }}
                                        onShowInfoClick={ () => {
                                            setCollapsedSources( [...SbUtils.updateArray( source.account_id,collapsedSources )] );
                                        }}


                                    />
                                )
                            } )
                        }
                    </div>
                }
                {
                    sources.sourcesList.length === 0 &&
                    <div className='sb-emptysources-notice'>
                        <span className='sb-fs sb-text-small sb-dark-text'>{ __( 'Looks like you have not added any source. Use “Add Source” to add a new one.' , 'sb-customizer') }</span>
                        <Button
                            text={ __( 'Add Source', 'sb-customizer' ) }
                            type='secondary'
                            size='medium'
                            icon='plus'
                            boxshadow={ false }
                            iconSize='14'
                            onClick={ () => {
                                addSourcePopup()
                            } }
                        />
                    </div>
                }
            </div>
            {
                addSourcesModalActive &&
                <ModalContainer
                    size={window.fbConnectProcess === true ? 'small' : 'medium'}
                    closebutton={true}
                    onClose={ () => {
                        setAddSourcesModalActive( false )
                    } }
                >
                    <AddSourceModal
                        openDialog={ () => {
                            setAddSourcesModalActive( true )
                        } }
                        onCancel={ () => {
                            setAddSourcesModalActive( false )
                        } }
                    />
                </ModalContainer>
            }
        </>
    )
}

export default SelectSourcesSection;